<div class="principal-container">
  <div class="steps">
    <app-stepper action="confirmation"></app-stepper>
  </div>
  <div class="confirm-container">
    <div *ngIf="estado_transaccion === 4">
      <mat-icon class class="cancel-icon" matPrefix>
        cancel
      </mat-icon>
      <p class="title-pending">Pago pendiente</p>
    </div>
    <div *ngIf="estado_transaccion === 5">
      <mat-icon class class="check-icon" matPrefix>
        check_circle
      </mat-icon>
      <p class="title">Pago realizado</p>
    </div>
    <div *ngIf="estado_transaccion === 6">
      <mat-icon class class="pending-icon" matPrefix>
        error
      </mat-icon>
      <p class="title-estado">Pago denegado</p>
    </div>
    <div *ngIf="estado_transaccion === 446">
      <mat-icon class class="pending-icon" matPrefix>
        error
      </mat-icon>
      <p class="title-estado">Pago no autorizado</p>
    </div>
    <div *ngIf="estado_transaccion === 348">
      <mat-icon class class="pending-icon" matPrefix>
        error
      </mat-icon>
      <p class="title-estado">Error al realizar el pago</p>
    </div>
    <p class="description">
      Gracias por su compra, revise su correo electrónico,
      <br />
      allí debió llegar su factura de compra.
    </p>
    <p class="total-payment-title">
      Total pagado
    </p>
    <p class="total-payment">
      {{ valor_transaccion }}
      <span class="cop">COP</span>
    </p>

    <button
      type="button"
      class="btn btn-outline-danger app-light-blue-button btn-finish"
      (click)="finish()"
    >
      Finalizar
    </button>
  </div>
</div>
<app-footer></app-footer>
